import React, { ReactNode } from "react";
import styles from "./index.module.scss";
import { buttonVariants } from "../../shared/ui/Button";

interface IOfferStatusInfo {
  iconSrc: string;
  isRotate?: boolean;
  title: string;
  subTitle?: ReactNode;
  description: ReactNode;
  buttonVariant?: buttonVariants;
  isBtnVisible: boolean;
  link: string | undefined;
  content?: ReactNode;
  bottomContent?: ReactNode;
}

export const OfferStatusInfo: React.FC<IOfferStatusInfo> = ({
  iconSrc,
  isRotate = false,
  title,
  subTitle = "",
  description,
  buttonVariant,
  isBtnVisible,
  link,
  content,
  bottomContent,
}) => {
  return (
    <div className={styles.waiting}>
      <div className={styles.waiting_container}>
        <div className="payment__status-header">
          <img
            src={iconSrc}
            className={`${styles.img} ${isRotate ? styles.img__rotate : ""}`}
            alt="Ваш счет формируется"
          />
          <h3 className={styles.title}>{title}</h3>
          {subTitle && subTitle}
          <p className={styles.description}>{description}</p>
        </div>
      </div>
      {content}
      {buttonVariant && isBtnVisible && (
        <a className={styles.link} href={link}>
          Вернуться на сайт
        </a>
      )}
      {bottomContent}
    </div>
  );
};
